import React from "react";
import styles from "./HeadingWithLine.module.scss";

function HeadingWithLine({ text, line = true, className, margin = true, badge = null }) {
  return (
    <div
      className={`${styles.heading_with_line} ${className} ${!margin && styles.noMargin}`}
    >
      {text && <h5>{text}</h5>}
      {badge}
      {line && <div className={styles.line}></div>}
    </div>
  );
}

export default HeadingWithLine;
